import { render, staticRenderFns } from "./JielvLaneMetrics.vue?vue&type=template&id=bc48b910&scoped=true"
import script from "./JielvLaneMetrics.vue?vue&type=script&lang=js"
export * from "./JielvLaneMetrics.vue?vue&type=script&lang=js"
import style0 from "./JielvLaneMetrics.vue?vue&type=style&index=0&id=bc48b910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48b910",
  null
  
)

export default component.exports